import Vue from 'vue';
import axios from 'axios';


Vue.mixin({
    created() {
        if (this.token == null) {
            this.Token = localStorage.getItem('Token');
        }
    },
    methods: {
        request(options) {
            let headers = {

            };
            if (this.Token) headers["x-access-token"] = this.Token;

            if (!options.method) {
                options.method = 'get';
            }
            if(options.forceFetch)
            {
                headers['tk_cache'] = new Date()
            }
            else
                headers["tk_cache"] = '1';
            return new Promise((resolve, reject) => {
                axios.request({
                    headers: headers,
                    url: this.endpoint() + options.url,
                    method: options.method,
                    data: options.data,
                    params: options.params,
                })
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    var errorObj = this.handleError(error);
                    if(errorObj.status == Vue.prototype.$lastErrorStatus)
                    {
                        var current = new Date().getTime();
                        if(current - Vue.prototype.$lastError < 4000)
                        {
                            return reject(errorObj);
                        }  
                    }
                    Vue.prototype.$lastError = new Date().getTime();
                    Vue.prototype.$lastErrorStatus = errorObj.status;
                    
                    if(errorObj.status === 401)
                    {
                        localStorage.removeItem('Token');
                        localStorage.removeItem('UserName');
                        localStorage.removeItem('photoUrl');
                        localStorage.removeItem('UserId');
                        localStorage.removeItem('widgets');
                        localStorage.removeItem('sjwt');
                        localStorage.removeItem('permissions');
                        this.$router.push({
                            path: '/login',
                            params: { nextUrl: this.$route.fullPath }
                          })
                       // window.location.href = '/';
                    }
                    if(errorObj.status === 400)
                    {
                        this.$notify({
                            title: errorObj.title,
                            text: errorObj.message,
                            group: 'alert'
                          })
                    }
                    else if(errorObj.status === 460)
                    {
                        this.$notify({
                            title: errorObj.title,
                            text: errorObj.message,
                            group: 'NotAccess'
                          })
                    }
                    else if(errorObj.status === 461)
                    {
                        return reject(errorObj);
                    }
                    else if(errorObj.status === 462)
                    {
                        return reject(errorObj);
                    }
                    else
                        Vue.notify({
                            group: 'foo',
                            type: 'error',
                            title: errorObj.title,
                            text: errorObj.message
                        });
                    return reject(errorObj);
                });
            })

        },
        endpoint(url) {
            let domain;
            domain = this.$BaseUrl + '/api';
            return domain;
        },
        setToken(token) {
            localStorage.setItem("Token", token);
        },
        handleError(error) {
            const errorResponse = {
              isValidationError: false,
              message: 'Network Error.',
              title: 'خطا',
              type: 'error',
              errors: [],
              status: 0,
              timeout: 2500,
            }
            const ErrorMessages = {
              400: 'داده های ارسالی شما قابل پذیرش نیستند. لطفا موارد زیر را اصلاح کنید',
              401: 'ما نیاز داریم مجددا شما را احراز هویت کنیم. لطفا مجددا لاگین کنید',
              403: 'عدم مجوز دسترسی. میتوانید از مدیر خود مجوز دسترسی بگیرید',
              404: 'یافت نشد',
              405: 'متد اجازه ندارد',
              500: 'متأسفیم، مشکلی پیش آمده. لطفا بعدا این مورد را امتحان کنید',
              request: 'ارتباط با سرور قطع است... لطفا اتصال شبکه یا اینترنت خود را بررسی کنید',
              other: 'There was some Problem with your Request, Please Try again Later',
            }
           
            if (error && error.response) {
                errorResponse.status = error.response.status;
                switch(error.response.status)
                {
                    
                    case 400: {
                        errorResponse.isValidationError = true
                
                        errorResponse.title = "خطا در داده های ارسالی"
                        console.log('salam az error' , error.response.data.message[0].message || error.response.data.message)
                        errorResponse.message = "لطفا موارد زیر را اصلاح کنید:" + "<br/>" + (error.response.data.message[0].message || error.response.data.message)
                        break;
                    }
                    case 401:  {
                        errorResponse.message = ErrorMessages['401']
                        errorResponse.title = "احراز هویت"
                        break;
                    } 
                    case 403:  {
                        errorResponse.title = "مجوز دسترسی"
                        errorResponse.message = ErrorMessages['403']
                        break;
                    }
                    case 404:  {
                        errorResponse.message = ErrorMessages['404']
                        break;
                    }
                    case 405:  {
                        errorResponse.message = ErrorMessages['405']
                        break
                    } 
                    case 422:  {
                        errorResponse.isValidationError = true
                        errorResponse.errors = error.response.data.errors
                        errorResponse.message = error.response.data.message
                        break
                    }
                    case 460: {
                        errorResponse.isValidationError = true
                        errorResponse.title = "محدودیت دسترسی"
                        errorResponse.message = error.response.data
                        break;
                    }
                    case 461:  {
                        errorResponse.isValidationError = true
                        errorResponse.errors = error.response.data
                        errorResponse.message = error.response.data
                        break
                    }
                    case 462:  {
                        errorResponse.isValidationError = true
                        errorResponse.errors = error.response.data
                        errorResponse.message = error.response.data
                        break
                    }
                    case 429:  {
                    }
                    default :{ 
                        if (error.response.status >= 500)
                            {
                                errorResponse.title = "مشکل فنی"
                                errorResponse.message = ErrorMessages['500']
                            }
                            else
                            {
                                var status = error.response.status;
                                var msg = error.response.data;
                                console.log('eeee',msg);
                            }
                    }
                }
            }
            else if (error && error.request) {
                errorResponse.title = "عدم ارتباط با سرور"
                errorResponse.message = ErrorMessages.request
                errorResponse.status = -1;
                // client never received a response, or request never left
            } 
            else if (error instanceof Error) {
                alert(1);
              errorResponse.message = error.message
            } 
            else if (typeof error === 'string') {
                alert(2);
              errorResponse.message = error
            } 
            else {
                alert(3);
              errorResponse.message = ErrorMessages.other
            }
            return errorResponse
          }
    },

})
